/* eslint-disable no-undef */
import { config } from "./config";

//just for debug need to see what configuration we have
console.debug(config());
